import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';

import AddressChangedModal from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddressChangedModal/AddressChangedModal';

import AddressChangedModalEN from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddressChangedModal/locales/AddressChangedModal_en_US';
import AddressChangedModalFR from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddressChangedModal/locales/AddressChangedModal_fr_CA';

const { wrapHOC } = FrameworkUtils;

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(AddressChangedModalEN, AddressChangedModalFR);

const localization = createStructuredSelector({
    modalTitle: getTextFromResource(getText, 'modalTitle'),
    message: getTextFromResource(getText, 'message'),
    nextShipment: getTextFromResource(getText, 'nextShipment'),
    shippingAddress: getTextFromResource(getText, 'shippingAddress'),
    gotIt: getTextFromResource(getText, 'gotIt')
});

const fields = createSelector(localization, locales => ({ localization: locales }));

const functions = {};

const withAddressChangedModalProps = wrapHOC(connect(fields, functions));

export default withAddressChangedModalProps(AddressChangedModal);
